export default __webpack_public_path__ + "static/media/insurance.c7d6f2e8.svg";